import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
//Global
import blockchain from './blockchain.reducer';
import karmaReducer from './karma.reducer';
import messageReducer from './message.reducer';
import ui from './ui.reducer';
import userReducer from './user.reducer';
//Credits
import credit from './credit.reducer';
//Order
import order from './order.reducer';
//App
import location from './app/location.reducer';
import vote from './app/vote.reducer';
import contact from './app/contact.reducer';
import kyc from './app/kyc.reducer';
import presale from './app/presale.reducer';
//Bounty
import bounty from './bounty/bounty.reducer';
import team from './bounty/team.reducer';
import jointeaminvitation from './bounty/jointeaminvitation.reducer';
import bountyMentor from './bountymentor.reducer';
//Codebase
import codebase from './codebase/codebase.reducer';
import github from './codebase/github.reducer';
import codebaseSponsor from './codebase/codebaseSponsor.reducer';
import publicProfile from './publicProfile.reducer';
import purchase from 'views/pages/payment/reducer';
//Kwallet
import kWallet from './kWallet.reducer';
import sale from 'views/pages/saleBeta/reducer';
import saleCampaign from './saleCampaign/saleCampaign.reducer';
import codeBase2 from './codeBase2/codeBase2.reducer';
//DAO
import dao from './dao.reducer';
import bountyDaoUI from './daoUI/bounty.reducer';
import revenueShare from './daoUI/revenueShare.reducer';

export default combineReducers({
  form: formReducer,
  routing: routerReducer,
  //Global
  blockchain,
  karma: karmaReducer,
  messageReducer,
  ui,
  user: userReducer,
  credit,
  order,
  kWallet,
  //App
  location,
  kyc,
  vote,
  contact,
  presale,
  //Bounty
  bounty,
  team,
  jointeaminvitation,
  bountyMentor,
  //Codebase
  codebase,
  github,
  codebaseSponsor,
  publicProfile,
  purchase,
  sale,
  saleCampaign,
  codeBase2,
  //DAO
  dao,
  bountyDaoUI,
  revenueShare
});
